const validEmailString: string =
    '^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)|' +
    '(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])' +
    '|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';

const validEmailStringRegex = RegExp(validEmailString);

/**
 * Helper function which checks if an email pattern is correct or not
 * @param email
 */
export const isEmail = (email: string): boolean => {
    return validEmailStringRegex.test(email);
};

/**
 * Function to get the email domain for the passed in email id.
 * Returns the domain in lowercase to match backend behavior (EmailUtils.java)
 * and ensure consistent case-insensitive domain comparisons.
 * @param email
 */
export const getEmailDomain = (email: string): string => {
    const index = email.lastIndexOf('@');
    let emailDomain = '';
    if (index !== -1) {
        emailDomain = email.substring(index + 1).toLowerCase();
    }
    return emailDomain;
};

/**
 * Checks if an email domain is whitelisted.
 * Supports wildcard '*' which allows all domains, and subdomain matching
 * (e.g., 'example.com' allows 'mail.example.com').
 *
 * This matches the backend behavior in EmailUtils.java:
 * - whiteListedDomains.contains("*") for wildcard
 * - emailDomain.equals(wld) || emailDomain.endsWith("." + wld) for subdomain matching
 *
 * @param emailDomain - The domain part of the email
 * @param whiteListedDomains - Array of allowed domains, may include '*'
 * @returns true if the domain is allowed
 */
export const isDomainWhitelisted = (
    emailDomain: string,
    whiteListedDomains: string[],
): boolean => {
    // Check wildcard first
    if (whiteListedDomains.includes('*')) {
        return true;
    }

    // Check exact match or subdomain match (matches backend EmailUtils.java logic)
    return whiteListedDomains.some(
        wld => emailDomain === wld || emailDomain.endsWith(`.${wld}`),
    );
};
